// Central configuration - Company owner can update phone/whatsapp here
export const COMPANY = {
  name: "SANTRAL EMLAK LTD",
  tagline: "31+ Yıl Kesintisiz Güven",
  license: "1603004",
  phone: "0-224-2246040",
  phoneRaw: "+902242246040",
  whatsapp: "0-532-2170338",
  whatsappRaw: "905322170338",
  email: "santralemlakltd@gmail.com",
  address: "Ahmet Hamdi Tanpınar Caddesi, Burçkin 2 İş Hanı, Kat 3, No 14, 16090 Osmangazi / Bursa",
  hours: "Pazartesi - Cumartesi: 09:00 - 19:00 · Pazar: Kapalı",
  mapEmbed: "https://www.google.com/maps?q=Ahmet+Hamdi+Tanp%C4%B1nar+Caddesi+Osmangazi+Bursa&output=embed",
};

export const waLink = (message) => {
  const encoded = encodeURIComponent(message || `Merhaba ${COMPANY.name}, bilgi almak istiyorum.`);
  return `https://wa.me/${COMPANY.whatsappRaw}?text=${encoded}`;
};

export const telLink = () => `tel:${COMPANY.phoneRaw}`;

export const formatTRY = (amount) => {
  if (amount == null) return "";
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(amount);
};

export const TRANSACTION_LABEL = { satilik: "Satılık", kiralik: "Kiralık" };
export const PROPERTY_TYPE_LABEL = {
  daire: "Daire", villa: "Villa", arsa: "Arsa", isyeri: "İşyeri", diger: "Diğer",
};
